export interface CaseDataResponse {
  customer: CustomerItem;
  callDetails: CallDetailsItem;
  location: LocationItem;
  vehicle: VehicleItem;
  casesteps: CaseLogItem[] | [];
  status: Status;
  response_message: string;
  app_code?: string;
}
export interface CaseLogItem {
  level: ErrorType;
  message: string;
  date: string;
  description?: string;
}
export interface CaseDataApiResponse {
  customer: CustomerApiResponse;
  case: CaseApiResponse;
  location: LocationApiResponse;
  vehicle: VehicleApiResponse;
  casesteps: CaseDataStepsApiResponse[];
  status: Status;
  response_message: string;
  app_code?: string;
}

export interface CaseDataStepsApiResponse {
  step_type: string;
  call_log: string;
  call_log_type: ErrorType;
  time_stamp: string;
}

export interface CaseItem {
  caseId?: string;
  serviceType?: string;
  eventTime?: string;
  clientPlatform?: string;
  clientName?: string;
}

export interface CaseApiResponse {
  case_id?: string;
  service_type?: string;
  event_datetime?: string;
  client_platform_type?: string;
  client_name?: string;
  phone_number?: string;
}

export interface CustomerItem {
  customerName?: string;
  emailAddress?: string;
  phoneNumber?: string;
  address?: string;
  preferredLanguage?: string;
  caseId?: string;
}

export interface CustomerApiResponse {
  customer_name?: string;
  email_address?: string;
  phone_number?: string;
  address?: string;
  preferred_language?: string;
  case_id?: string;
  time_stamp?: string;
  status: Status;
  response_message: string;
  first_name?: string;
  last_name?: string;
}

export interface CustomerApiRequest {
  customer_name?: string;
  email_address?: string;
  phone_number?: string;
  address?: string;
  preferred_language?: string;
  case_id?: string;
  time_stamp?: string;
}

export interface Brand {
  brandName: string;
  modelName: string;
  modelYear: string;
  modelCode: string;
  modelDesc: string;
}

export interface VehicleItem {
  caseId?: string;
  vin?: string;
  brand?: string;
  mileage?: number;
  mileageUnit?: OdometerScaleType;
  year?: string | number;
  color?: string;
  vehiclePhoneNumber?: string;
  model?: string;
}

export interface VehicleApiRequest {
  case_id?: string;
  vin?: string;
  brand?: string;
  model_name?: string;
  model_year?: string | number;
  model_code?: string;
  model_desc?: string;
  phone_number?: string;
  trim?: string;
  body_style?: string;
  basic_type?: string;
  color?: string;
  time_stamp?: string;
}

export interface VehicleApiResponse {
  case_id?: string;
  vin?: string;
  brand?: string;
  model_name?: string;
  model_year?: string;
  model_code?: string;
  model_desc?: string;
  phone_number?: string;
  trim?: string;
  body_style?: string;
  basic_type?: string;
  color?: string;
  updated_by?: string;
  time_stamp?: string;
  status: Status;
  response_message: string;
}

export interface VehicleMakeAPIResponse {
  data: Array<string>;
}

export interface VehicleDataRequest {
  msisdn: string;
  programCode: string;
}

export interface VehicleDataResponse {
  location: Location;
  vehicle: VehicleItem;
  status: Status;
  responseMessage: string;
}

export interface LocationApiRequest {
  latitude?: number;
  longitude?: number;
  location_address?: {
    heading_direction?: string | null;
    street?: string | null;
    street_number?: string | null;
    postal_code?: string | null;
    city?: string | null;
    province?: string | null;
    state?: string | null;
    country?: string | null;
  };
  time_stamp?: string;
}

export interface LocationItem {
  caseId?: string;
  latitude?: number;
  longitude?: number;
  headingDirection?: string | null;
  street?: string | null;
  streetNumber?: string | null;
  province?: string | null;
  city?: string | null;
  state?: string | null;
  country?: string | null;
  postalCode?: string | null;
  timeStamp?: string | null;
  agentextension?: string;
}

export interface LocationAddress {
  heading_direction?: string | null;
  street?: string | null;
  street_number?: string | null;
  city?: string | null;
  state?: string | null;
  postal_code?: string | null;
  province?: string | null;
  country?: string | null;
}
export interface LocationApiResponse {
  case_id?: string;
  status: number;
  response_message: string;
  latitude?: number;
  longitude?: number;
  location_address?: LocationAddress;
  time_stamp?: string;
}

export enum OdometerScaleType {
  MILES = 'Miles',
  KILOMETERS = 'Kilometers',
}

export enum Status {
  SUCCESS = 200,
  CREATED = 201,
  NOT_FOUND = 404,
  INTERNAL_SERVER_ERROR = 500,
  UNKNOWN = 0,
  INVALID_STATE_ERROR = 403,
  BAD_REQUEST = 400,
  NOT_IMPLEMENTED = 501,
  GATEWAY_TIMEOUT = 504,
  METHOD_NOT_ALLOWED = 405,
  UNAUTHORIZED = 401,
  SERVICE_UNAVAILABLE = 503,
}
export type ErrorType = 'FATAL' | 'ERROR' | 'WARN' | 'INFO';
export interface CaseStepsItem {
  caseId: string;
  stepType: string;
  callLog: string;
  callLogType: ErrorType;
  timeStamp?: string;
  agentextension?: string;
}

export interface CaseStepsApiRequest {
  case_id: string;
  step_type: string;
  call_log: string;
  call_log_type: ErrorType;
  time_stamp: string;
}

export interface CaseStepsApiResponse {
  case_id: string;
  step_type: string;
  call_log: string;
  call_log_type: ErrorType;
  time_stamp: string;
  status: Status;
  response_message: string;
}

export enum CaseSteps {
  INITIALIZATION = 'Initialization',
  CASE_RETRIEVED = 'CaseRetrieved',
  VEHICLE_VALIDATED = 'VehicleValidated',
  VEHICLE_VALIDATION_FAILED = 'VehicleValidationFailed',
  RSA_DISPATCH_REQUEST = 'RSADispatchRequest',
  RSA_DISPATCH_FAILED = 'DispatchFailed',
  RSA_DISPATCH_SUCCESS = 'DispatchSuccess',
  JOB_COMPLETE = 'JobComplete',
  LOCATION_VALIDATED = 'LocationValidated',
  LOCATION_VALIDATION_FAILED = 'LocationValidationFailed',
  CUSTOMER_VALIDATED = 'CustomerValidated',
  CUSTOMER_VALIDATION_FAILED = 'CustomerValidatedFailed',
  ADDRESS_OUTSIDE_US = 'AddressOutsideUS',
  ADDRESS_REQUIRED = 'AddressRequired',
  E911_CONNECT_APP_CASE_CREATION_IN_PROGRESS = 'E911ConnectAppCaseCreationInProgress',
  E911_CONNECT_APP_CASE_CREATED = 'E911ConnectAppCaseCreated',
  E911_CONNECT_APP_LAUNCH_IN_PROGRESS = 'E911ConnectAppLaunchInProgress',
  E911_CONNECT_APP_CASE_CREATION_FAILED = 'E911ConnectAppCaseCreationFailed',
}

export enum CallLog {
  INITIALIZATION = 'Incoming Call Detected',
  CASE_RETRIEVED = 'Case Details Retrieved',
  ADDRESS_VALIDATED = 'Address Successfully Validated',
  ADDRESS_REQUIRED = 'Address is Required',
  LOCATION_VALIDATION_FAILED = 'Location Validation Failed:Reenter the address',
  CALL_FAILED = 'Call Failed',
  CASE_CREATION_INPROGRESS = 'Case creation - In Progress',
  DRAFT_JOB_NOT_CREATED = 'Draft Job Could Not Be Created',
  DRAFT_JOB_CREATED = 'Draft Job Has Been Created',
  VEHICLE_UPDATE_SUCCESS = 'Vehicle Details Updated',
  VEHICLE_UPDATE_FAILED = 'Vehicle Details Update Failed',
  CUSTOMER_UPDATE_SUCCESS = 'Customer Details Updated',
  CUSTOMER_UPDATE_FAILED = 'Customer Details Update Failed',
  CASE_CREATION_SUCCESS = 'Case Id Successfully Created',
  CASE_CREATION_FAILED = 'Case Id Creation Failed',
  E911_CONNECT_APP_CASE_CREATION_IN_PROGRESS = 'Creating a case in 911Connect App',
  E911_CONNECT_APP_CASE_CREATED = 'Created a case in 911Connect App',
  E911_CONNECT_APP_LAUNCH_IN_PROGRESS = 'Launching 911Connect App',
  E911_CONNECT_APP_CASE_CREATION_FAILED = 'Case creation failed in 911Connect App',
}
export interface CallDetailsItem {
  caseId?: string;
  program?: string;
  service?: string;
  phoneNumber?: string;
}

export interface CallDetailsApiResponse {
  case_id?: string;
  client_name?: string;
  service_type: string;
  status?: Status;
  response_message?: string;
}

export interface CallDetailsApiRequest {
  caseId?: string;
  program?: string;
  service?: string;
}

export const ServiceType = {
  BreakdownAssistanceCall: 'Breakdown Assistance Call',
  InformationCall: 'Information Call',
  ECALL: 'SOS/Emergency Call',
  AutomaticCrashNotification: 'Automatic Crash Notification',
};

export const ClientName = {
  toyota: 'Toyota',
  subaru: 'Subaru',
};

export interface LoginData {
  email_address?: string;
  agent_extension?: string;
  extension_logs?: any;
  reason?: string;
}

export interface LoginApiRequest {
  email_address?: string;
  agent_extension?: string;
  login_time_stamp?: string;
  extension_logs?: any;
  reason?: string;
}

export interface LoginApiResponse {
  status: number;
  response_message: string;
  agent_email?: string;
  agent_extension?: string;
  login_timestamp?: string;
}

export interface ProfileItem {
  emailAddress: string;
  isComplete: boolean;
  eventTime?: string;
  clientPlatform: ClientPlatformItem[];
}

export interface ProfileApiRequest {
  email_address: string;
  client_platforms: ClientPlatformApiResponse[];
}

export interface ProfileApiResponse {
  status: number;
  response_message: string;
  email_address: string;
  time_stamp?: string;
  is_complete: boolean;
  client_platforms: ClientPlatformApiResponse[];
}

export interface ClientPlatformItem {
  clientName: string;
  clientPlatformType: string;
  userName: string;
  notApplicable: boolean;
  clientLabel: string;
}
export interface ClientPlatformApiResponse {
  client_name: string;
  client_platform_type: string;
  user_name: string;
  is_applicable: boolean;
}

export interface DispatchCaseApiResponse {
  time_stamp?: string;
  status: number;
  result: DispatchJob;
  response_message: string;
}

export interface DispatchJob {
  job_id: string;
}

export interface LocationCallLogMessage {
  description?: string;
  title: string;
}

export interface ExtensionLogResponse {
  extension?: string;
  first_name?: string;
  last_name?: string;
  email?: string;
  check_in_time?: string;
  duration?: number;
  check_out_time?: string;
  release_time?: string;
  modified_by?: string;
  modified_date?: string;
  can_release?: boolean;
  can_modify?: boolean;
}

export interface AgentExtensionLogsApiResponse {
  status: number;
  response_message?: string;
  extension_log?: ExtensionLogResponse;
}

export interface AgentExtensionLogData {
  extension: string;
  check_in_time: string;
  check_out_time: string;
  release_time: string;
  first_name?: string;
  last_name?: string;
  email?: string;
  duration?: number;
  modified_by?: string;
  modified_date?: string;
  can_release?: boolean;
  can_modify?: boolean;
}

export interface CaseCompletionResponse {
  status: Status;
  response_message: string;
}

export interface LatLongData {
  latitude: number;
  longitude: number;
}

export interface GoogleMapCoordinatesData {
  is_google_map_coordinates: boolean;
  google_map_coordinates: LatLongData[];
}

export interface GoogleMapCoordinates {
  google_map_coordinates: LatLongData[];
}

export interface E911ConnectAppVehicleRequest {
  color?: string | null;
  year?: string | null;
  vin?: string | null;
}

export interface E911ConnectAppLocationRequest {
  latitude: string;
  longitude: string;
}

export interface E911ConnectAppRequest {
  agentExtension: string;
  incidentId: string;
  customerNumber?: string;
  customerName?: string;
  vehicle?: E911ConnectAppVehicleRequest;
  location: E911ConnectAppLocationRequest;
}

export interface E911ConnectAppResponse {
  agent_extension: string;
  case_id: string;
  ui_url: string;
  status: Status;
  response_message: string;
}

export interface AbstractConfigResponse {
  is_google_map_coordinates?: boolean;
  google_map_coordinates?: LatLongData[];
  status?: Status;
  response_message?: string;
}
